module.exports = __webpack_public_path__ + "img/iconewhats.68ed8f75.png";